var _style, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemove1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "line-color",
    d: "M19.288,18.497L15.291,14.5l3.997-3.997c0.219-0.219,0.219-0.572,0-0.791c-0.218-0.219-0.573-0.219-0.791,0L14.5,13.709 l-3.997-3.997c-0.218-0.219-0.573-0.22-0.791,0c-0.219,0.219-0.219,0.572,0,0.791l3.997,3.997l-3.997,3.997 c-0.106,0.106-0.164,0.246-0.164,0.395c0,0.151,0.058,0.29,0.164,0.396c0.213,0.21,0.578,0.21,0.791-0.001l3.997-3.996l3.997,3.998 c0.106,0.105,0.246,0.163,0.395,0.163c0.148,0,0.29-0.058,0.395-0.164s0.164-0.246,0.164-0.395 C19.451,18.743,19.393,18.603,19.288,18.497z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.952,
    y: 7.952,
    className: "st0",
    width: 13.097,
    height: 13.097
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove1);
export default __webpack_public_path__ + "static/media/icon-remove-1.bc01f4ae3bf331f8b078a75aab952118.svg";
export { ForwardRef as ReactComponent };